import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import PropTypes from 'prop-types'; // ES6
import { Row, Col, Card, Button, Spin } from 'antd';

import { convertirTextAMomentUTC, MASCARA_DDMMYYYY, MASCARA_YYYYMMDD } from '../../commons/gestioDates';
import { obtenirNomMoment } from '../commons/periodes';
import { rutaObservacions } from '../../routes/routeConstants';
import ObservacioIntroduccioDadesEstacio from './observacioIntroduccioDadesEstacio';
import ObservacioIntroduccioVariables from './observacioIntroduccioVariables';
import ObservacioIntroduccioHoraObservacio from './observacioIntroduccioHoraObservacio';
import {
    observacioFormulariEnviar,
    onEnterObservacioCrearEditar,
    observacioFormulariInicialitzar
} from '../../actions';
import { RETARD_MILISEGONS_APARICIO_SPINNER } from '../../constants';
import obtenirDetallEstacio from '../../selectors/selector_estacio_per_codi';

import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

class ObservacioIntroduccio extends Component {

    constructor(props) {
        super(props);

        this.onClickButtonGuardar = this.onClickButtonGuardar.bind(this);
    }

    componentDidMount() {
        this.props.onEnterObservacioCrearEditar();
    }

    onClickButtonGuardar() {
        const { dataHoraObservacio, variablesFormulari, observacioFormulariEnviar, router } = this.props;
        observacioFormulariEnviar(dataHoraObservacio.dataHoraObservacio, dataHoraObservacio.dataHoraObservacioNou, variablesFormulari, router);
    }

    dadesPreparades() {
        return this.props.dataSeleccionada
            && this.props.periodeSeleccionat
            && this.props.dataHoraObservacio
            && this.props.estacio
            && this.props.variablesFormulari;
    }

    componentWillUnmount() {
        this.props.observacioFormulariInicialitzar();
    }

    render() {

        const {
            peticioObtenirFormulariEnCurs,
            dataSeleccionada,
            periodeSeleccionat,
            dataHoraObservacio,
            peticioInserirEnCurs,
            variablesFormulari,
            estacio
        } = this.props;

        if (!this.dadesPreparades() && !peticioObtenirFormulariEnCurs) {
            return (
                <div className="observacio-introduccio-error-carregant-formulari">
                    <h4>S'ha produït un error</h4>
                    <Button icon='left' onClick={this.props.router.goBack}>Tornar</Button>
                </div>
            );
        } else if (!this.dadesPreparades() && peticioObtenirFormulariEnCurs) {
            return (
                <div className="observacio-introduccio-carregant-formulari" >
                    <Spin
                        style={{ margin: 'auto' }}
                        spinning={peticioObtenirFormulariEnCurs}
                        delay={RETARD_MILISEGONS_APARICIO_SPINNER}
                        tip='Carregant...'
                    />
                </div>
            );
        }

        const dataSeleccionadaAsMoment = convertirTextAMomentUTC(dataSeleccionada, MASCARA_YYYYMMDD);
        const diaSeleccionatAsText = dataSeleccionadaAsMoment.format(MASCARA_DDMMYYYY);
        const nomPeriodeSeleccionat = obtenirNomMoment(periodeSeleccionat);

        return (
            <div>
                <Row className='camp'>
                    <Col className="observacio-introduccio-dades-observacio-detall">
                        <Card title='Dades observació' className="observacio-introduccio-dades-observacio-box" bordered={false}>
                            <Spin spinning={peticioInserirEnCurs} delay={RETARD_MILISEGONS_APARICIO_SPINNER}>
                                <div className='observacio-introduccio-detall'>
                                    <div><span>Estació: </span><span>{estacio.nom}</span></div>
                                    <div><span>Data: </span><span>{diaSeleccionatAsText} - {nomPeriodeSeleccionat}</span></div>
                                </div>
                                <ObservacioIntroduccioHoraObservacio
                                    dataSeleccionada={dataSeleccionada}
                                    dataHoraObservacio={dataHoraObservacio}
                                />
                                <ObservacioIntroduccioVariables variablesFormulari={variablesFormulari} periodeSeleccionat={nomPeriodeSeleccionat} />
                                <div>
                                    <Button size='large' type='primary' disabled={peticioInserirEnCurs} onClick={this.onClickButtonGuardar}>Guardar</Button>
                                    <Link to={rutaObservacions}>
                                        <Button size='large' className='boto-cancellar' disabled={peticioInserirEnCurs}>Cancel·lar</Button>
                                    </Link>
                                </div>
                            </Spin>
                        </Card>
                    </Col>
                    <Col className="observacio-introduccio-dades-estacio-box">
                        <ObservacioIntroduccioDadesEstacio estacio={estacio}></ObservacioIntroduccioDadesEstacio>
                    </Col>
                </Row>
            </div>
        );
    }
}

ObservacioIntroduccio.propTypes = {
    variablesFormulari: PropTypes.object,
    dataHoraObservacio: PropTypes.object,
    estacio: PropTypes.object,
    dataSeleccionada: PropTypes.string,
    periodeSeleccionat: PropTypes.string,
    peticioInserirEnCurs: PropTypes.bool,
    peticioObtenirFormulariEnCurs: PropTypes.bool,
    router: PropTypes.object,
    observacioFormulariEnviar: PropTypes.func,
    observacioFormulariInicialitzar: PropTypes.func,
    onEnterObservacioCrearEditar: PropTypes.func
};

const mapStateToProps = (state) => ({
    variablesFormulari: state.observacio.formulari.variables,
    dataHoraObservacio: state.observacio.formulari.dataHoraObservacio,
    peticioInserirEnCurs: state.observacio.formulari.peticioInserirEnCurs,
    peticioObtenirFormulariEnCurs: state.observacio.formulari.peticioObtenirFormulariEnCurs,
    dataSeleccionada: state.observacio.dataSeleccionada,
    periodeSeleccionat: state.observacio.periodeSeleccionat,
    dataActual: state.dataActual,
    estacio: obtenirDetallEstacio(state)
});

const mapDispatchToProps = { onEnterObservacioCrearEditar, observacioFormulariEnviar, observacioFormulariInicialitzar };

export default errorBoundaryWrapper(connect(mapStateToProps, mapDispatchToProps)(ObservacioIntroduccio));



// WEBPACK FOOTER //
// ./src/components/observacio/observacioIntroduccio.js